const routes=[
  {
    path:'/',
    component:()=>import("../views/home/Index.vue")
  },
  {
    path:"/bookmarks",
    component:()=>import("../views/bookmarks/Index.vue")
  },
  {
    path:"/coding",
    component:()=>import("../views/coding/Index.vue")
  },
  {
    path:"/test",
    component:()=>import("../views/test/Index.vue")
  },
  {
    path:"/favorites",
    component:()=>import("../views/favorites/Index.vue")
  },
  {
    path:"/mpim",
    component:()=>import("../views/mpim/Index.vue")
  },
  {
    path:"/dataBase",
    component:()=>import("../views/dataBase/Index.vue")
  }
]
export default routes;